import { useQuery } from "@tanstack/react-query";
import viewService from "../api/viewService";

export const useView = (viewId) => {
  const { getView } = viewService();

  return useQuery({
    queryKey: ["get-view", viewId],
    queryFn: async () => {
      const res = await getView(viewId);
      return res.data;
    },
    enabled: !!viewId
  });
};

/**
 * Used for custom views in the grid. It does not update or go stale,
 * to avoid unnecessary re-rendering of the grid.
 */
export const useViewUnmanaged = (viewId) => {
  const { getView } = viewService();

  return useQuery({
    queryKey: ["unmanagedgetviews", viewId],
    queryFn: async () => {
      const res = await getView(viewId);
      return res.data;
    },
    enabled: !!viewId,
    notifyOnChangeProps: [viewId, "isPending"],
    subscribed: false,
    staleTime: Infinity
  });
};

export const useViews = (boardId) => {
  const { getViews } = viewService();

  return useQuery({
    queryKey: ["get-views", boardId],
    queryFn: async () => {
      const res = await getViews(boardId);
      return res.data;
    },
    enabled: !!boardId
  });
};
